module.exports = __webpack_public_path__ + "static/media/iglogo.ff854302.png";